import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { YesNoRadioButtons } from 'components/shared/ButtonsGroup/YesNoRadioButtons';
import { getCurrencySymbol } from 'components/shared/NewAmountInput/CurrencySymbol';
import { FC } from 'react';

import { TradeWayField } from '../shared';
import { Block } from '../shared/Blocks/Block';
import { VerticalFormGroup } from '../shared/VerticalFormGroup';
import { ConnectedDealSplit } from './components/dealSplit';
import type { QuoteRealtimeFormDetailsProps } from './QuoteRealtimeFormDetails.connect';
import { connectQuoteRealtimeFormDetail } from './QuoteRealtimeFormDetails.connect';

const fieldIds: string[] = [
  'quantity',
  'notional',
  'tradeWay',
  'hasUpfrontFee',
  'unallocatedNotional',
  'custodian',
  'allocated-notional',
];

export const Component: FC<QuoteRealtimeFormDetailsProps> = ({
  tabId,
  canEditUpfrontFee,
  currency,
  hasUpfrontFee,
  notional,
  quantity,
  tradeWay,
  unallocatedNotional,
  onNotionalChanged,
  onQuantityChanged,
  onTradeWayChanged,
  onUpfrontFeeChanged,
  frozen,
}) => {
  const currencySymbol = getCurrencySymbol(currency);

  return (
    <Block label="secondaryMarket.tradeInformation.label.tradeInformation" id="product-details" fieldIds={fieldIds}>
      <div>
        <div className="row">
          <VerticalFormGroup inputId="quantity" label="quantity" className="col-md-6">
            <AmountWithUnit
              onChange={onQuantityChanged}
              e2e="quantity"
              incrementStep={1}
              unit="Notes"
              value={quantity}
              isReadOnly={frozen}
            />
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="notional"
            label="secondaryMarket.tradeInformation.label.tradeNotional"
            className="col-md-6"
          >
            <AmountWithUnit
              value={notional}
              unit={currencySymbol}
              e2e="tradeNotional"
              onBlur={onNotionalChanged}
              incrementStep={1}
              isReadOnly={frozen}
            />
          </VerticalFormGroup>
        </div>
        <div className="row">
          <VerticalFormGroup
            inputId="tradeWay"
            label="secondaryMarket.tradeInformation.tradeWay.label"
            className="col-md-6"
          >
            <TradeWayField value={tradeWay} onTradeWayChange={onTradeWayChanged} canEditTradeWay={!frozen} />
          </VerticalFormGroup>
          <VerticalFormGroup inputId="hasUpfrontFee" label="upfrontFee" className="col-md-6">
            <YesNoRadioButtons
              className="w-100"
              id="hasUpfrontFee"
              e2e="upfrontFee"
              value={hasUpfrontFee ?? null}
              onSelect={onUpfrontFeeChanged}
              isDisabled={!canEditUpfrontFee || frozen}
            />
          </VerticalFormGroup>
        </div>
        <div className="row">
          <VerticalFormGroup
            inputId="unallocatedNotional"
            label="secondaryMarket.tradeInformation.label.unallocatedNotional"
            className="col-12"
          >
            <AmountWithUnit
              id="unallocatedNotional"
              e2e="unallocatedNotional"
              unit={currencySymbol}
              value={unallocatedNotional ?? null}
              isReadOnly
            />
          </VerticalFormGroup>
        </div>
        <div className="row">
          <ConnectedDealSplit tabId={tabId} />
        </div>
      </div>
    </Block>
  );
};

Component.displayName = 'QuoteRealtimeFormDetails';

export const QuoteRealtimeFormDetails = connectQuoteRealtimeFormDetail(Component);
